/* eslint-disable */
import React from 'react';

import { ROUTES } from './routes.js';
import Link from '../atoms/Link/Link';

const { config } = window.appAirDrop;

// PiUi Error Codes:
export const PIUIERRCODE_ACCOUNT_IS_LOCKED = 'piui.accountIsLocked';
export const PIUIERRCODE_ACCOUNT_IS_NOT_ACTIVE = 'piui.accountIsNotActive';
export const PIUIERRCODE_PI_NO_SMS_SUBSCRIPTION = 'pi.noSmsSubscription';
export const PIUIERRCODE_PI_SESSION_PER_USER_EXCEEDED_THRESHOLD = 'pi.sessionPerUserExceededThreshold';
export const PIUIERRCODE_CLOCK_SKEW = 'piui.clockSkew';
export const PIUIERRCODE_AUTH_FAILURE = 'piui.authFailure';
export const PIUIERRCODE_AUTH_FAILURE_LEGACY = 'piui.authFailureLegacy';
export const PIUIERRCODE_BLOCKED_EMAIL_DOMAIN = 'piui.blockedEmailDomain';
export const PIUIERRCODE_NO_SUCH_EMAIL_ADDRESS = 'piui.noSuchEmailAddress';
export const PIUIERRCODE_NO_SUCH_USERNAME = 'piui.noSuchUsername';
export const PIUIERRCODE_TOO_MANY_USERNAMES = 'piui.tooManyUsernames';
export const PIUIERRCODE_TOO_MANY_TICKETS = 'piui.tooManytickets';
export const PIUIERRCODE_INVALID_CLIENTID = 'piui.invalidClientId';
export const PIUIERRCODE_NO_SUCH_ESCROW_TICKET = 'piui.noSuchEscrowTicket';
export const PIUIERRCODE_ACCOUNT_IS_PENDING = 'piui.accountIsPending';
export const PIUIERRCODE_INVALID_ESCROW_TICKET = 'piui.invalidEscrowTicket';
export const PIUIERRCODE_INVALID_AUO_ESCROW_TICKET = 'piui.auoCreatePasswordEscrowExpired';
export const PIUIERRCODE_GENERAL_SERVER_ERROR = 'piui.generalServerError';
export const PIUIERRCODE_PI_GENERAL_SERVER_ERROR = 'pi.generalServerError';
export const PIUIERRCODE_PI_INVALID_ESCROW_CODE = 'pi.invalidEscrowCode';
export const PIUIERRCODE_PI_INVALID_EMAIL_ESCROW_CODE = 'pi.invalidEmailEscrowCode';
export const PIUIERRCODE_PI_EXPIRED_ESCROW = 'pi.expiredEscrow';
export const PIUIERRCODE_PI_EXPIRED_EMAIL_ESCROW = 'pi.expiredEmailEscrow';
export const PIUIERRCODE_PI_DUPLICATE_USERNAME = 'pi.duplicateUsername';
export const PIUIERRCODE_PI_DUPLICATE_USERNAME_SOCIAL = 'pi.duplicateUsernameSocial';
export const PIUIERRCODE_PI_DUPLICATE_USERNAME_SOCIAL_CR = 'pi.duplicateUsernameSocialCr';
export const PIUIERRCODE_CREATE_ACCOUNT_ESCROW_EXPIRED = 'pi.expiredEscrow';
export const PIUIERRCODE_RESET_PW_LINKS_EXPIRED_ESCROW = 'pi.resetPwLinksExpiredEscrow';
export const PIUIERRORCODE_SHOWFAILED_TEXT = 'pi.failedTextSend';
export const PIUIERRCODE_CREATE_ACCOUNT_INSTITUTIONS_SERVICE_ERROR = 'piui.institutionsServiceError';
export const PIUIERRCODE_RECAPTCHA_LOW_SCORE = 'piui.recaptchaLowScore';
export const PIUIERRCODE_RECAPTCHA_LOW_SCORE_SIGN_IN_WITH_CODE = 'piui.recaptchaLowScoreSwc';
export const PIUIERRCODE_NEW_VERIFICATION = 'piui.sentNewVerificationCode';
export const PIUIERROR_CODE_RECONSENT = 'piui.reconsent';
export const PIUIERRORCODE_GENERATED_PASSWORD_ERROR = 'piui.generatedPasswordUserAuthFailure';
export const PIUIERRORCODE_SMS_SUB_ERROR = 'smssubscriptionerror';
export const PIUIERRORCODE_TIMED_OUT_ERROR = 'piui.sessionTimedOut';
export const PIUIERRORCODE_NO_QUESTIONS_FOUND = 'piui.noSecurityQuestionsFound';
export const PIUIERRORCODE_PHONENUMBER_NOT_FOUND = 'piui.phoneNumberNotFound';
export const PIUIERRORCODE_FAILED_PHONENUMBER = 'pi.failedPhoneNumber';
export const PIUIERRORCODE_INCORRECT_ANSWERS = 'pi.incorrectSecurityQuestionAnswers';
export const PIUIERRCODE_SECURITY_QUESTIONS_ESCROW_EXPIRED = 'piui.securityQuestionsEscrowExpired';
export const PIUIERRCODE_NO_QUESTIONS_FOUND = 'piui.noSecurityQuestionsFound';
export const PIUIERRCODE_FAILED_GROUP_MANAGER = 'pi.failedGroupManager';
export const PIUIERRCODE_FAILED_EMAIL_SEND = 'pi.failedEmailSend';
export const PIUIERRCODE_REGISTRAR_ASSOCIATE_USER_FAIL = 'pi.registrar.associate.user.fail';
export const PIUIERRORCODE_UNAUTHORIZED_LINKING_ATTEMPT = 'pi.unauthorizedLinkingAttempt';
export const PIUIERRCODE_SIGNIN_WITH_CODE_TOO_MANY_ATTEMPTS = 'pi.retryAttemptsExceeded';
export const PIUIERRCODE_NO_EMAIL_FOR_USER = 'piui.noMailPnForSigninWithCode';
export const PIUIERRCODE_INVALID_USERNAME = 'piui.invalidUsername';
export const PIUIERRCODE_PASSWORD_CONTAINS_USERNAME = 'pi.usernameNotAllowedInPassword';
export const PIUIERRCODE_SIGN_IN_CODE_ESCROW_EXPIRED = 'pi.expiredSignInWithCodeEscrow';
export const PIUIERRCODE_SIGN_IN_CODE_INVALID = 'piui.invalidSignInCode';

export const SOFT_ERROR_CODES = [PIUIERRCODE_FAILED_GROUP_MANAGER,
  PIUIERRCODE_FAILED_EMAIL_SEND,
  PIUIERRCODE_REGISTRAR_ASSOCIATE_USER_FAIL];

// Link indicator
export const LINK_INDICATOR = '%LINK%';

// Field validation error messages
export const ERRMSG_USERNAME_REQUIRED = 'Username is required.';
export const ERRMSG_USERNAME_ALREADY_USED = 'Username is already being used.'
export const ERRMSG_EMAIL_REQUIRED = 'Email address is required.';
export const ERRMSG_CONFIRM_EMAIL_REQUIRED = 'Confirm email address is required.';
export const ERRMSG_EMAIL_ADDRESS_NOT_VALID = 'Email address is not valid.';
export const ERRMSG_VALID_EMAIL_ADDRESS_REQUIRED = 'A valid email address is required.';
export const ERRMSG_EMAILS_MISMATCH = 'Email address and Confirm email address do not match.';
export const ERRMSG_FIRST_NAME_REQUIRED = 'First name is required.';
export const ERRMSG_FIRSTNAME_NO_SPECIAL_CHARS = "First name cannot contain numbers or special characters other than ' . -";
export const ERRMSG_SMS_FIRSTNAME_NO_SPECIAL_CHARS = "First name cannot contain numbers or special characters other than ' -";
export const ERRMSG_HED_FIRSTNAME_NO_SPECIAL_CHARS = "First name cannot contain special characters other than ' . - ? [ ]";
export const ERRMSG_FIRSTNAME_CANNOT_EXCEED_40_CHARS = 'First name can be no more than 40 characters.';
export const ERRMSG_FIRSTNAME_CANNOT_EXCEED_32_CHARS = 'First name can be no more than 32 characters.';
export const ERRMSG_LAST_NAME_REQUIRED = 'Last name is required.';
export const ERRMSG_LASTNAME_CANNOT_EXCEED_40_CHARS = 'Last name can be no more than 40 characters.';
export const ERRMSG_LASTNAME_CANNOT_EXCEED_64_CHARS = 'Last name can be no more than 64 characters.';
export const ERRMSG_LASTNAME_NO_SPECIAL_CHARS = "Last name cannot contain numbers or special characters other than ' . -";
export const ERRMSG_SMS_LASTNAME_NO_SPECIAL_CHARS = "Last name cannot contain numbers or special characters other than ' -";
export const ERRMSG_HED_LASTNAME_NO_SPECIAL_CHARS = "Last name cannot contain special characters other than ' . - ? [ ]";
export const ERRMSG_PASSWORD_REQUIRED = 'Password is required.';
export const ERRMSG_PASSWORD_MISSING_8_CHARS = 'Your password must have 8 or more characters.';
export const ERRMSG_PASSWORD_MISMATCH = "Your password and confirmation don't match. Let's try that again.";
export const ERRMSG_PASSWORD_NO_SPECIAL_CHARS = 'Password cannot contain special characters other than _ @ . -';
export const ERRMSG_PASSWORD_MISSING_UPPER_NUMBER_MINLENGTH =
  'Your password must have 8 characters or more, at least 1 uppercase letter, and 1 number.';
export const ERRMSG_PASSWORD_NO_SPACES = 'Password cannot contain spaces.';
export const ERRMSG_PASSWORD_MISSING_5_CHARS = 'Your password must have 5 or more characters.';
export const ERRMSG_PASSWORD_CANNOT_EXCEED_120_CHARS = 'Password can be no more than 120 characters.';
export const ERRMSG_CONFIRM_PASSWORD_MISSING = 'Confirm new password is required.';
export const ERRMSG_USERNAME_NO_SPECIAL_CHARS = 'Username cannot contain special characters other than _ @ . - $ , +';
export const ERRMSG_SMS_USERNAME_NO_SPECIAL_CHARS = 'Username cannot contain special characters other than _ @ . -';
export const ERRMSG_USERNAME_MISSING_4_CHARS = 'Username must be at least 4 characters.';
export const ERRMSG_USERNAME_CANNOT_EXCEED_120_CHARS = 'Username can be no more than 120 characters.';
export const ERRMSG_CONSENT_REQUIRED = 'You must agree to the Terms of use and acknowledge the Privacy notice.';
export const ERRMSG_TURKEY_CONSENT_REQUIRED = 'This field is required.';
export const ERRMSG_SCHOOL_CODE_REQUIRED = 'Your school code is required.';
export const ERRMSG_MOBILE_NUMBER_REQUIRED = 'Mobile phone number is required.';
export const ERRMSG_MOBILE_NUMBER_INVALID = 'Mobile phone number is invalid.';
export const ERRMSG_VERIFICATION_CODE_REQUIRED = 'Verification code is required.';
export const ERRMSG_SIGNIN_CODE_REQUIRED = 'Sign in code is required.';
export const ERRMSG_ANSWER_IS_REQUIRED = 'Answer is required.';
export const ERRMSG_COUNTRY_IS_REQUIRED = 'Country is required.';
export const ERRMSG_COUNTRY_IS_INVALID = 'Country not found.';
export const ERRMSG_INSTITUTION_IS_REQUIRED = config.logoTreatment === 'mpp_hed_italy' ? 'University is required.' : 'Institution is required.';
export const ERRMSG_INSTITUTION_IS_INVALID = config.logoTreatment === 'mpp_hed_italy' ? 'University not found.' : 'Institution not found.';
export const ERRMSG_ROLE_IS_REQUIRED = 'Role is required.';
export const ERRMSG_STUDY_LEVEL_IS_REQUIRED = 'Study level is required.';
export const ERRMSG_DOB_IS_REQUIRED = 'Date of birth is required.';
export const ERRMSG_ESCROW_IS_INVALID = 'Sorry, this page expired. Please refresh the page to continue.';
export const ERRMSG_MAX_SEND_CODE_REACHED = 'You have reached the maximum send verification code attempts for this mobile phone number. Please use the email option.';
export const EMAIL_ERRMSG_MAX_SEND_CODE_REACHED = 'You have reached the maximum send verification code attempts for this email address. Please try again later.';
export const USER_ERRMSG_MAX_SEND_CODE_REACHED = 'You have reached the maximum send verification code attempts for this user. Please try again later.';
export const ERRMSG_MAX_SEND_CODE_REACHED_NO_EMAIL = 'You have reached the maximum send verification code attempts for this mobile phone number. Please try again later.';

// Password policies
export const FIVE_CHAR_PASSWORD_POLICY = 'fiveCharacters';
export const EIGHT_CHAR_SIMPLE_PASSWORD_POLICY = 'eightCharactersSimple';

interface ReturnType {
  msg?: string | React.ReactNode;
  key?: string | React.ReactNode;
  code?: string | number | React.ReactNode;
}
// Error Messages Mappings to PiUi Codes
export function PiUiErrCodeToErrMsgMapFn(piErrorCode: any): ReturnType {
  let msg: string | React.ReactNode = null;
  let key: string | React.ReactNode = null;
  let code: string | number | React.ReactNode = null;
  switch (piErrorCode) {
    case PIUIERRCODE_ACCOUNT_IS_LOCKED:
      msg = (
        <>
          {'Your account is locked. To unlock it, try to '}
          <Link to={`${ROUTES.FORGOT_UN_PW_INTERNAL}`}>reset your password</Link>.
        </>
      );
      key = 'accountIsLocked';
      code = null;
      break;
    case PIUIERRCODE_ACCOUNT_IS_NOT_ACTIVE:
      msg = (
        <>
          {"This account isn't active. Try a different username or contact "}
          <a
            href="https://support.pearson.com/getsupport/s/"
            target="_blank"
            rel="noreferrer"
            title="opens in a new tab or window"
          >
            Pearson Support
          </a>
          .
        </>
      );
      key = 'accountIsNotActive';
      code = null;
      break;
    case PIUIERRORCODE_SMS_SUB_ERROR:
    case PIUIERRCODE_PI_NO_SMS_SUBSCRIPTION:
      msg = (
        <>
          Please
          {config.signupConfig?.url !== '' ? <a href={config.signupConfig?.url}>{' register'}</a> : ' register'} before signing
          in.
        </>
      );
      key = config.signupConfig?.url !== '' ? 'noSMSSubscriptionRegister' : 'noSMSSubscription';
      code = null;
      break;

    case PIUIERRCODE_SECURITY_QUESTIONS_ESCROW_EXPIRED:
      msg = 'Sorry, the security questions page expired. Please try again.';
      key = null;
      code = null;
      break;
    case PIUIERRORCODE_INCORRECT_ANSWERS:
      msg = 'The answer given to one or more of your security questions is wrong. Please try again.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_NO_QUESTIONS_FOUND:
      msg = 'You have not set up your security questions. Please choose the Email option to reset your password, or if you\'re in a classroom, contact your teacher.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_PI_SESSION_PER_USER_EXCEEDED_THRESHOLD:
      msg =
        `Whoops! You've reached our limit of ${config.userSessionThreshold || 5} active sessions at one time for your Pearson` +
        ' product. To free up a session, sign out in a browser or device and sign in again.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_CLOCK_SKEW:
      msg =
        'The time zone, date, or clock for your computer or other device is set incorrectly. Make sure your date and clock match' +
        ' your time zone.';
      key = null;
      code = null;
      break;
    case PIUIERRORCODE_NO_QUESTIONS_FOUND:
      msg = 'You have not set up your security questions. Please choose the Email option to reset your password, or if you\'re in a classroom, contact your teacher.'
      key = null;
      code = null;
      break;
    case PIUIERRCODE_AUTH_FAILURE:
      msg = "We can't find an account with this email and password. Please try again.";
      key = null;
      code = null;
      break;
    case PIUIERRCODE_AUTH_FAILURE_LEGACY:
      msg = "That username or password didn't work.";
      key = null;
      code = null;
      break;
    case PIUIERRCODE_BLOCKED_EMAIL_DOMAIN:
      msg = 'Your institution has prevented user registration through the Pearson website. Please log in through your LMS.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_NO_SUCH_EMAIL_ADDRESS:
      msg = 'The email address you entered is not in our system. Please try again.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_NO_SUCH_USERNAME:
      msg = "We can't find anyone with this username. Please try again.";
      key = null;
      code = null;
      break;
    case PIUIERRCODE_TOO_MANY_USERNAMES:
      msg = 'Too many usernames associated with this email address.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_TOO_MANY_TICKETS:
      msg = 'Too many tickets for this resource.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_INVALID_CLIENTID:
      msg = 'Invalid client Id.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_NO_SUCH_ESCROW_TICKET:
      msg = 'Escrow ticket not found.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_ACCOUNT_IS_PENDING:
      msg = 'Account Creation is not complete. Please try again later.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_INVALID_ESCROW_TICKET:
      msg = 'Your password reset link has expired. Please re-enter your email address to receive a new link.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_INVALID_AUO_ESCROW_TICKET:
      msg = 'Your create password link expired. Enter your email address again to get a new link.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_PI_GENERAL_SERVER_ERROR:
      msg = "Sorry, something went wrong. We're working on fixing this. Please try again later.";
      key = null;
      code = null;
      break;

    case PIUIERRCODE_PI_INVALID_ESCROW_CODE:
      msg = 'The verification code is incorrect. Try again or select Send new code.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_PI_INVALID_EMAIL_ESCROW_CODE:
      msg = 'The verification code is incorrect. Try again or select Resend.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_PI_EXPIRED_ESCROW:
      msg = 'Sorry, this page expired. Please refresh the page to continue.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_RESET_PW_LINKS_EXPIRED_ESCROW:
      msg = 'Sorry, this page has expired.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_PI_EXPIRED_EMAIL_ESCROW:
      msg = 'This code has expired. Please resend to receive a new one.';
      key = null;
      code = null;
      break;

    case PIUIERRCODE_FAILED_GROUP_MANAGER:
      msg = 'Your account has been successfully created. You may need to select your role on first sign-in.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_FAILED_EMAIL_SEND:
      msg = 'Your account has been successfully created. You may need to confirm your email address on first sign-in.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_REGISTRAR_ASSOCIATE_USER_FAIL:
      msg = 'Your account has been successfully created. You may need to add Institution Association later.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_NEW_VERIFICATION:
      msg = 'A new verification code was sent.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_PI_DUPLICATE_USERNAME:
      msg = (
        <>
          {'An account with this information already exists. Please '}
          <Link to={ROUTES.LOGIN_INTERNAL}>{'sign in'}</Link>
          {' or '}
          <Link to={`${ROUTES.FORGOT_UN_PW_INTERNAL}`}>reset your password</Link>.
        </>
      );
      key = 'genUserAlreadyExistsErrorMsg';
      code = null;
      break;
    case PIUIERRCODE_PI_DUPLICATE_USERNAME_SOCIAL:
      msg = (
        <>
          {'An account with this information already exists. Please sign in to that account or '}
          <Link to={`${ROUTES.FORGOT_UN_PW_INTERNAL}`}>reset your password</Link>.
        </>
      );
      key = 'piuiErrCodePiDuplicateUsernameSocial';
      code = null;
      break;
    case PIUIERRCODE_PI_DUPLICATE_USERNAME_SOCIAL_CR:
      msg = (
        <>
          {'An account with this information already exists. Please '}
          <Link to={ROUTES.LOGIN_INTERNAL}>{'sign in'}</Link>
          {' to that account or '}
          <Link to={`${ROUTES.FORGOT_UN_PW_INTERNAL}`}>reset the password</Link>.
        </>
      );
      key = 'piuiErrCodePiDuplicateUsernameSocialCr';
      code = null;
      break;
    case PIUIERRCODE_CREATE_ACCOUNT_INSTITUTIONS_SERVICE_ERROR:
      msg = 'We are having trouble communicating with an external system. Please try again later.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_RECAPTCHA_LOW_SCORE:
      msg = (
        <>
          {'Error verifying reCAPTCHA, please try again or contact '}
          <a
            href="https://support.pearson.com/getsupport/s/"
            target="_blank"
            rel="noreferrer"
            title="opens in a new tab or window"
          >
            Pearson Support
          </a>
          .
        </>
      );
      key = 'recaptchaLowScore';
      code = null;
      break;
    case PIUIERRCODE_RECAPTCHA_LOW_SCORE_SIGN_IN_WITH_CODE:
      msg = (
        <>
          {'reCAPTCHA verification failed. Please '}
          <Link to={ROUTES.LOGIN_INTERNAL}>{'try another sign in method'}</Link>
          .
        </>
      );
      key = 'recaptchaLowScoreSwc';
      code = null;
      break;
    case PIUIERRORCODE_SHOWFAILED_TEXT:
      msg = (
        <>
          {"Sorry, we can't text you now. Please try again later or contact"}
          <a
            href={config.customSupportLinkUrl}
            target="_blank"
            rel="noreferrer"
            title={'link opens in a new tab or window'}
          >
            Pearson Support.
          </a>
          .
        </>
      );
      key = 'showFailedText';
      code = null;
      break;
    case PIUIERRORCODE_GENERATED_PASSWORD_ERROR:
      msg = 'You need to create a password to sign in using your Pearson account. Check your email for a link.';
      key = null;
      code = null;
      break;
    case PIUIERRORCODE_TIMED_OUT_ERROR:
      msg = 'Your session has ended. Please sign in again.'
      key = null;
      code = null;
      break;
    case PIUIERRORCODE_PHONENUMBER_NOT_FOUND:
      msg = `The mobile phone number doesn't match the one associated with your account.`;
      key = null;
      code = null;
      break;
    case PIUIERRORCODE_FAILED_PHONENUMBER:
      msg = 'The mobile phone number you entered is not in our system. Please try again.';
      key = null;
      code = null;
      break;
    case PIUIERRORCODE_UNAUTHORIZED_LINKING_ATTEMPT:
      msg = 'Unauthorized account linking attempt.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_INVALID_USERNAME:
      msg = 'Invalid username. Please try again.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_PASSWORD_CONTAINS_USERNAME:
      msg = 'Your password cannot contain your username. Please choose a different password to keep your account secure.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_NO_EMAIL_FOR_USER:
      msg = 'This option is not available. Please try a different option.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_SIGN_IN_CODE_ESCROW_EXPIRED:
      msg = 'Sorry, this page expired. Return to sign in to continue.';
      key = null;
      code = null;
      break;
    case PIUIERRCODE_SIGN_IN_CODE_INVALID:
      msg = 'Invalid code. Please resend code and try again.';
      key = null;
      code = null;
      break;
    default:
    case PIUIERRCODE_GENERAL_SERVER_ERROR:
      msg = "Sorry, something went wrong. We're working on fixing this. Please try again later.";
      key = null;
      code = null;
      break;
  }
  return { msg, key, code };
}

export function genericSocialErrorMsg(inputCode: string): React.ReactNode {
  return (
    <>
      {"Sorry, something went wrong on our end. Try again later. If that doesn't work, contact "}
      <a
        href="https://support.pearson.com/getsupport/s/"
        target="_blank"
        rel="noreferrer"
        title="link opens in a new tab or window"
      >
        Pearson Support
      </a>
      {` and give them this code: ${inputCode}`}
    </>
  );
}

export function genUserAlreadyExistsErrorMsg(): React.ReactNode {
  return (
    <>
      {'An account with this information already exists. Please '}
      <Link to={ROUTES.LOGIN_INTERNAL}>{'sign in '}</Link>
      {'or '}
      <Link to={`${ROUTES.FORGOT_UN_PW_INTERNAL}`}>reset your password</Link>.
    </>
  );
}

export const defaultInitialError = {
  msg: null,
  key: null,
  code: null,
};
